enum SpendingMoneyInOutIndicator {
  OUT = 'OUT',
  IN = 'IN',
  NTRL = 'NTRL',
}

export default SpendingMoneyInOutIndicator;
